import React, { useState, createContext, useContext, useRef, useEffect } from 'react'
import { useTranslate } from 'react-admin';
import ReactDOM from 'react-dom'
import { cx, css } from '@emotion/css'
import escapeHtml from 'escape-html'
import { Editor, Transforms, Element as SlateElement, Text, Node } from 'slate'
import { ReactEditor, useSlate, useSlateStatic, useFocused, useSelected, } from 'slate-react'
import { jsx } from 'slate-hyperscript'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button as MButton } from '@mui/material';
import { Image as ImageIcon, Delete, Edit, UploadFile } from '@mui/icons-material';
import { insertElement } from './slateInsert';
import dataProvider from '../dataProvider';
import {  getInfoValue } from '../globalData';
import mammoth from 'mammoth';
import PostalMime from 'postal-mime';

const ParamContext = createContext();

const ParamProvider = ({ children }) => {
  const [vars, setVars] = useState([{id:'placeholder', label:'placeholder'}]);
  const [images, setImages] = useState([]);
  const [email, setEmail ] = useState('')
  const hostel_id = getInfoValue('id_hostel');
  useEffect(() => {
    dataProvider.getOne('setHostel', { id: hostel_id, sort: { }, pagination: { page: 1, perPage: 999 }})
    .then(res  => {
      console.log(res?.data?.res_email)
      setEmail(res?.data?.res_email)
    })
    // eslint-disable-next-line
  }, [hostel_id]);

  return (
    <ParamContext.Provider value={{ vars, setVars, images, setImages, email }}>
      {children}
    </ParamContext.Provider>
  );
};

const ImageButton = ({editor, handleImage, icon=<ImageIcon />, classN}) => {
  const [ dlgOpen, setDlgOpen ] = useState(false)
  return (
    <>
      <span
        onClick={event => {
          event.preventDefault()
          setDlgOpen(true)
        }}
        className={classN}
        style={{ verticalAlign: 'text-bottom'}}
      >
        {icon}
      </span>
      <Dialog open={dlgOpen} onClose={()=>setDlgOpen(false)}>
        <DialogTitle>Select an Image</DialogTitle>
        <DialogContent>
          <SelectImageInput editor={editor} setDlg={setDlgOpen} handleImage={handleImage} />
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>setDlgOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

const SelectImageInput = ({editor, setDlg, handleImage}) => {
  const { images } = useContext(ParamContext)
  console.log([images])
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
      {images.map((img) => (
        <img
          key={img.text}
          src={img.text}
          alt={img.id_element}
          style={{ width: 100, cursor: 'pointer' }}
          onClick={() => {handleImage(editor, img.text);setDlg(false)}}
        />
      ))}
    </div>
  );
}

const Image = ({ attributes, children, element }) => {
  const editor = useSlateStatic()
  const path = ReactEditor.findPath(editor, element)
  const selected = useSelected()
  const focused = useFocused()

  const handleClick = (ev) => {
    ev.preventDefault()
    Transforms.select(editor, path)
  }

  const handleImage = (ed, value) => {
    Transforms.setNodes(
      editor,
      { url: value },
      { at: path } 
    );
  }
  return (
    <div {...attributes}>
      {children}
      <div contentEditable={false} className={css`position: relative;`} >
        <img
          src={element.url}
          alt={element.url}
          className={css`
            display: block;
            width: ${element?.width?element.width+'px':''};
            height: ${element?.height?element.height+'px':''};
            min-width: 5em;
            max-width: 100%;
            min-height: 5em;
            box-shadow: ${selected && focused ? '0 0 0 3px #B4D5FF' : 'none'};
          `}
          onClick={ev => handleClick(ev)}
        />
        <ImageButton editor={editor} handleImage={handleImage} icon={<Edit />} 
          classN={css`display: ${selected && focused ? 'inline' : 'none'}; position: absolute;
          padding: 0.2em; top: 0.5em; left: 0.5em; background-color: white;`}
        />
        <Button active onClick={() => Transforms.removeNodes(editor, { at: path })}
          className={css`display: ${selected && focused ? 'inline' : 'none'}; 
          position: absolute; padding: 0.2em; top: 0.5em; left: 3em; background-color: white;`}
        >
          <Delete />
        </Button>
      </div>
    </div>
  )
}

const InsertInput = ({editor, node, path, icon=null}) => {
  const tr = useTranslate();
  const [open, setOpen] = useState(false);
  const props = {editor: editor, setOpen: setOpen, node: node, path: path}
  //console.log(path)
  return (
    <div>
      <Button active={true} onClick={() => setOpen(!open)}>{icon?<Icon>{icon}</Icon>:tr('bw.set.bookingsheet.insert')}</Button>

      {open && (
        <div style={{ position: 'absolute', background: '#fff', border: '1px solid #ccc', padding: '8px', zIndex: '100', minWidth: '19em' }}>
          <InsertElementButton {...props} type="paragraph" />
          <InsertElementButton {...props} type="div" />
          <InsertElementButton {...props} type="span" />
          <InsertElementButton {...props} type="br" />
          <InsertElementButton {...props} type="var" />
          <br />
          <InsertElementButton {...props} type="link" />
          <InsertElementButton {...props} type="image" />
          <InsertElementButton {...props} type="quote" />
          <InsertElementButton {...props} type="hr" />
          <InsertElementButton {...props} type="font" />
          <br />
          <InsertElementButton {...props} type="headingone" />
          <InsertElementButton {...props} type="headingtwo" />
          <InsertElementButton {...props} type="headingthree" />
          <InsertElementButton {...props} type="headingfour" />
          <InsertElementButton {...props} type="headingfive" />
          <InsertElementButton {...props} type="headingsix" />
          <br />
          <InsertElementButton {...props} type="numberedlist" />
          <InsertElementButton {...props} type="bulletedlist" />
          <InsertElementButton {...props} type="listitem" />
          <br />
          <InsertElementButton {...props} type="table" />
          <InsertElementButton {...props} type="tablerow" />
          <InsertElementButton {...props} type="tablehead" />
          <InsertElementButton {...props} type="tablecell" />
        </div>
      )}
    </div>
  );
}

const DocumentInput = ({editor, values, handleSetFixed, handleSetHeader}) => {
  const fileInputRef = useRef(null);

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = async (e) => {
      const arrayBuffer = e.target.result;

      try {
        var html = ''
        if(file.name.endsWith(".eml")){
          const email = await PostalMime.parse(arrayBuffer)
          html = email.html
        }
        else {
          const result = await mammoth.convertToHtml({ arrayBuffer });
          html = result.value;
        }

        //console.log(html)
        Transforms.delete(editor, {
          at: [0],
        });
        
        Transforms.insertNodes(editor, deserializeHtml(html, values, handleSetFixed, handleSetHeader), {
          at: [0],
        });
      } catch (error) {
        console.error('Failed to import .'+file.name+':', error);
      }
    };

    reader.readAsArrayBuffer(file);
  };

  return (
    <div>
      <Button active={true} onClick={handleClick}><Icon><UploadFile /></Icon></Button>
      <input
        type="file"
        accept=".docx, .eml"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
    </div>
  );
}

// In attribute values (href/src), <var>NAME</var> must be normalized back to %NAME%
// before HTML-escaping, otherwise escapeHtml() would turn it into &lt;var&gt;NAME&lt;/var&gt;.
const normalizeVarInAttr = (value) => {
  if (typeof value !== 'string') return value
  return value.replace(/<var>([^<>]*)<\/var>/g, '%$1%')
}

const addAttrs = (node) => {
  var ret = ''
  var style = ''
  const excludeAttrs = ['style', 'url', 'type', 'children', 'text'];

  if(node.style){
    if(typeof node.style === 'object'){
      style = Object.keys(node.style).map(key => {
        const value = node.style[key];
        return `${key.replace(/([A-Z])/g, '-$1').toLowerCase()}: ${value};`;
      }).join(' ');
    }
  }
  for (const attr in node) {
    if (excludeAttrs.includes(attr)) continue;
    if (node[attr] !== undefined && node[attr] !== null) {
      ret += ` ${attr}="${escapeHtml(normalizeVarInAttr(node[attr]))}"`;
    }
  }

  if(node.url){
    // eslint-disable-next-line
    if(node.type == 'link')ret = ret+' href="'+escapeHtml(normalizeVarInAttr(node.url))+'"'
    // eslint-disable-next-line
    if(node.type == 'image')ret = ret+' src="'+escapeHtml(normalizeVarInAttr(node.url))+'"'
  }
  if(style !== '')ret = ret+' style="'+style+'"'
  return ret
}

const checkForVars = (node) => {
  if (Array.isArray(node.children)) {
    for (const child of node.children) {
      if(child.type === 'table')return ''
      if (typeof child.text === 'string' && child['var'] === true && child.text.includes('.')) {
        return child.text.split('.')[0];
      } else if (Array.isArray(child.children)) {
        const result = checkForVars(child);
        if (result !== null) return result;
      }
    }
  }
  return null;
}

const groupVars = ['Bookings', 'Services', 'Payments', 'VAT', 'GroupBookings', 'GroupServices', 'GroupPayments', 'GroupVAT']

const serialize = node => {
  //console.log ('serialize')
  if (Text.isText(node)) {
    let string = escapeHtml(node.text)
    // eslint-disable-next-line
    if(node.text == '\r\n') string = '<br />'
    if(node.var){
      string = `<var>${string}</var>`
    } 
    if(node.font){
      string = `<font`+addAttrs(node)+`>${string}</font>`
    } 
    if(node.bold) string = `<b>${string}</b>`
    if(node.code) string = `<code>${string}</code>`
    if(node.italic) string = `<i>${string}</i>`
    if(node.strikethrough) string = `<s>${string}</s>`
    if(node.underline) string = `<u>${string}</u>`
    if(node.br) string = '<br />\n'
    return string
  }

  const children = node.children.map(n => serialize(n)).join('')

  switch (node.type) {
    case 'link':
      return '<a'+addAttrs(node)+'>'+children+'</a>'
    case 'quote':
      return '<blockquote'+addAttrs(node)+'>'+children+'</blockquote>'
    case 'bulletedlist':
      return '<ul'+addAttrs(node)+'>'+children+'</ul>\n'
    case 'headingone':
      return '<h1'+addAttrs(node)+'>'+children+'</h1>\n'
    case 'headingtwo':
      return '<h2'+addAttrs(node)+'>'+children+'</h2>\n'
    case 'headingthree':
      return '<h3'+addAttrs(node)+'>'+children+'</h3>\n'
    case 'headingfour':
      return '<h4'+addAttrs(node)+'>'+children+'</h4>\n'
    case 'headingfive':
      return '<h5'+addAttrs(node)+'>'+children+'</h5>\n'
    case 'headingsix':
      return '<h6'+addAttrs(node)+'>'+children+'</h6>\n'
    case 'image':
      return '<img'+addAttrs(node)+'>'+children+'</img>'
    case 'listitem':
      return '<li'+addAttrs(node)+'>'+children+'</li>\n'
    case 'numberedlist':
      return '<ol'+addAttrs(node)+'>'+children+'</ol>\n'
    case 'table':
      return '<table'+addAttrs(node)+'>\n'+children+'</table>\n'
    case 'tablebody':
      return '<tbody'+addAttrs(node)+'>\n'+children+'</tbody>\n'
    case 'tablerow':
      const childVar = checkForVars(node)
      const rowNode = {...node}
      if(groupVars.includes(childVar))rowNode.list = childVar
      return '<tr'+addAttrs(rowNode)+'>\n'+children+'</tr>\n'
    case 'tablecell':
      return '<td'+addAttrs(node)+'>'+children+'</td>\n'
    case 'font':
      return '<font'+addAttrs(node)+'>'+children+'</font>'
    case 'hr':
      return '<hr'+addAttrs(node)+' />\n'
    case 'br':
      return '<br />\n'
    case 'paragraph':
      return '<p'+addAttrs(node)+'>'+children+'</p>\n'
    case 'div':
      return '<div'+addAttrs(node)+'>'+children+'</div>\n'
    case 'var':
      return '<var'+addAttrs(node)+'>'+children+'</var>'
    case 'span':
      return '<span'+addAttrs(node)+'>'+children+'</span>'
    default:
      return children
  }
}

const read_style = (styleString) => {
  if(!styleString || typeof styleString !== 'string')return null
  const styleObject = {};
  const properties = styleString.toLowerCase().split(';');
  properties.forEach(property => {
    const [propertyName, value] = property.trim().split(':');
    if (propertyName && value) {
      styleObject[propertyName.replace(/-([a-z])/g, (match, group) => group.toUpperCase())] = value.trim();
    }
  });
  //console.log(styleString)
  //console.log(styleObject)
  return styleObject
}

const getAttributes = (el, exclude = [], defaults = {}) => {
  const attrs = Array.from(el.attributes).reduce((acc, attr) => {
    if (!exclude.includes(attr.name)) {
      if(attr.name === 'style')acc[attr.name] = read_style(attr.value)
      else acc[attr.name] = attr.value;
    }
    return acc;
  }, {});

  // Add defaults for missing keys
  Object.entries(defaults).forEach(([key, value]) => {
    if (!(key in attrs)) {
      attrs[key] = value;
    }
  });

  return attrs;
};

const ELEMENT_TAGS = {
  A: el => ({ type: 'link', url: el.getAttribute('href'), ...getAttributes(el, ['href'], {}) }),
  IMG: el => ({ type: 'image', url: el.getAttribute('src'), ...getAttributes(el, ['src'], {width:null, height:null, alt:null}) }),
  TABLE: el => ({ type: 'table', style: read_style(el.getAttribute('style')), ...getAttributes(el, ['style'], {width:null, cellspacing:null, cellpadding:null, border:null}) }),
  TBODY: () => ({ type: 'tablebody' }),
  TR: el => ({ type: 'tablerow', ...getAttributes(el, []) }),
  TH: el => ({ type: 'tablehead', style: read_style(el.getAttribute('style')), ...getAttributes(el, ['style'], {width:null, align:null, colspan:null, rowspan:null}) }),
  TD: el => ({ type: 'tablecell', style: read_style(el.getAttribute('style')), ...getAttributes(el, ['style'], {width:null, align:null, colspan:null, rowspan:null}) }),
  P: el => ({ type: 'paragraph', ...getAttributes(el, [], {}) }),
  DIV: el => ({ type: 'div', style: read_style(el.getAttribute('style')), ...getAttributes(el, ['style'], {}) }),
  SPAN: el => ({ type: 'span', style: read_style(el.getAttribute('style')), ...getAttributes(el, ['style'], {}) }),
  BLOCKQUOTE: () => ({ type: 'quote' }),
  H1: () => ({ type: 'headingone' }),
  H2: () => ({ type: 'headingtwo' }),
  H3: () => ({ type: 'headingthree' }),
  H4: () => ({ type: 'headingfour' }),
  H5: () => ({ type: 'headingfive' }),
  H6: () => ({ type: 'headingsix' }),
  LI: () => ({ type: 'listitem' }),
  OL: () => ({ type: 'numberedlist' }),
  UL: () => ({ type: 'bulletedlist' }),
  FONT: el => ({ type: 'font', ...getAttributes(el, [], {size:null, face:null}) }),
  HR: el => ({ type: 'hr', ...getAttributes(el, [], {size:null}) }),
  //BR: () => ({ type: 'br' }),
  PRE: () => ({ type: 'pre' }),
}

// COMPAT: `B` is omitted here because Google Docs uses `<b>` in weird ways.
const TEXT_TAGS = {
  CODE: () => ({ code: true }),
  DEL: () => ({ strikethrough: true }),
  B: () => ({ bold: true }),
  EM: () => ({ italic: true }),
  I: () => ({ italic: true }),
  S: () => ({ strikethrough: true }),
  STRONG: () => ({ bold: true }),
  U: () => ({ underline: true }),
  BR: () => ({ br: true }),
  VAR: () => ({ var: true }),
}

const escapeHTMLString = (el) => {
  const container = document.createElement('div');
  container.appendChild(el.cloneNode(true));
  return container.innerHTML;
}

const deserializeHtml = (html, values, setFixed, setHead) => {
  //console.log ('deserialize')
  var fixedIdx = 0

  function hasNonTextTagDescendants(node) {
    for (const child of node.childNodes) {
      const childName = child.nodeName.toUpperCase()
      if (ELEMENT_TAGS[childName]) return true
      if (hasNonTextTagDescendants(child)) return true
    }
    return false
  }

  function fixNode(node, stack = []) {
    //console.log(['fixNode', node, stack])

    if (node.nodeType === 3) {
      const text = node.textContent;
      if (!text){
        return [{ text: '' }];
      } 

      let result = { text: text };
      //console.log(stack)
      for (let i = stack.length - 1; i >= 0; i--) {
        const tagNode = stack[i];
        const tagName = tagNode.nodeName.toUpperCase();
        const attrs = TEXT_TAGS[tagName](tagNode);
        result = jsx('text', attrs, [result]);
        //if(typeof result?.text !== 'String')console.log(result)
      }
      return result;
    }

    if (node.nodeType !== 1) {
      //console.log('not-element')
      return [{ text: '' }];
    }

    const nodeName = node.nodeName.toUpperCase();
    const isTextTag = Boolean(TEXT_TAGS[nodeName]);
    const containsNonText = hasNonTextTagDescendants(node);
    //console.log(['params', nodeName, isTextTag, containsNonText ])

    const newStack = isTextTag && containsNonText ? [...stack, node] : stack;
    // Recurse into children first
    
    let results = [];

    for (const child of node.childNodes) {
      const result = fixNode(child, newStack);
      if (Array.isArray(result)) {
        results.push(...result);
      } else if (result) {
        results.push(result);
      }
    }

    
    var elAttrs = {}
    if(Boolean(ELEMENT_TAGS[nodeName])){
      elAttrs = ELEMENT_TAGS[nodeName](node)
    }
    /*else {
      console.log([nodeName, node])
    }*/
    if (isTextTag){
      if(!containsNonText) {
        if(results.length>1){
          let res =  []
          for(let i = 0; i < results.length; i++){
            res.push(jsx('text', TEXT_TAGS[nodeName](node), results[i]))
        }
        return res
        }
        if(results.length === 0){
          return jsx('text', TEXT_TAGS[nodeName](node), [{ text: '' }]);
        }
        //console.log(results)
        if(results[0]?.text){
          return jsx('text', TEXT_TAGS[nodeName](node), results[0]);
        }
        return jsx('text', TEXT_TAGS[nodeName](node), results[0]?.children?.length >1 ? results[0]?.children[0] : [{ text: '' }]);
      }
      else {
        return results
      }
    }
    else if(node.childNodes?.length === 0){
      return jsx('element', elAttrs, [{ text: '' }]);
    }

    if(results.length>1){
      let res =  []
      for(let i = 0; i < results.length; i++){
        res.push(jsx('element', elAttrs, results[i]))
      }
      return res
    }
    return jsx('element', elAttrs, results[0]);
  }

  const deserialize = el => {
    if (el.nodeType === 3) {
      return el.textContent
    } else if (el.nodeType !== 1) {
      return null
    } 

    let { nodeName } = el
    let parent = el
    if (
      nodeName === 'PRE' &&
      el.childNodes[0] &&
      el.childNodes[0].nodeName === 'CODE'
    ) {
      parent = el.childNodes[0]
    }
    let children = Array.from(parent.childNodes).map(deserialize).flat()
    if (children.length === 0 || (children.length === 1 && children[0] === null)) {
      children = [{ text: '' }]
    }
    if (el.nodeName === 'BODY') {
      return jsx('fragment', {}, children)
    }
    if (ELEMENT_TAGS[nodeName]) {
      const attrs = ELEMENT_TAGS[nodeName](el)
      return jsx('element', attrs, children)
    }
    if (TEXT_TAGS[nodeName]) {
      const attrs = TEXT_TAGS[nodeName](el)
      if(hasNonTextTagDescendants(el)){
        const fixed = fixNode(el);
        fixedIdx = 1
        return fixed
      }
      let nodes = []
      try {
        nodes = children.map(child =>
          jsx(typeof child.type !== 'undefined' ? 'element' : 'text', attrs, child)
          );
        } catch (error) {
          //console.error('Error deserializing children:', error);
          //console.log(['faulty node', { text: escapeHTMLString(el) }])
          dataProvider.update('setBookingsheet/faulty_nodes', {id: values.id, data: {err: error, id_hostel:values.id_hostel, data: escapeHTMLString(el)} })
          nodes = { text: escapeHTMLString(el) }
          fixedIdx = 2
      }
      return nodes
    }
    return children
  }

  if (html) {
    const sanHtml = html.replace(/\s*[\r\n]\s*/g, '').replace(/\s{2,}/g, ' ').trim();
    const parsed = new DOMParser().parseFromString(sanHtml, 'text/html')
    const fragment = deserialize(parsed.body)
    if(parsed?.head?.outerHTML)setHead(parsed.head.outerHTML)
    if(!fragment.length || (fragment.length === 1 && !fragment[0].type)){
      return [jsx('element', {type: 'div'}, {text: 'Text ...'})]
    }
    setFixed(fixedIdx)
    return fragment
  }
  return []
}

const LIST_TYPES = ['numberedlist', 'bulletedlist']
const TEXT_ALIGN_TYPES = ['left', 'center', 'right', 'justify']


const toggleBlock = (editor, format) => {
  const isActive = isBlockActive(
    editor,
    format,
    TEXT_ALIGN_TYPES.includes(format) ? 'align' : 'type'
  )
  const isList = LIST_TYPES.includes(format)
  Transforms.unwrapNodes(editor, {
    match: n =>
      !Editor.isEditor(n) &&
      SlateElement.isElement(n) &&
      LIST_TYPES.includes(n.type) &&
      !TEXT_ALIGN_TYPES.includes(format),
    split: true,
  })
  let newProperties
  if (TEXT_ALIGN_TYPES.includes(format)) {
    newProperties = {
      align: isActive ? undefined : format,
    }
  } else {
    newProperties = {
      type: isActive ? 'paragraph' : isList ? 'listitem' : format,
    }
  }
  Transforms.setNodes(editor, newProperties)
  if (!isActive && isList) {
    const block = { type: format, children: [] }
    Transforms.wrapNodes(editor, block)
  }
}

const toggleMark = (editor, format) => {
  const isActive = isMarkActive(editor, format)
  if (isActive) {
    Editor.removeMark(editor, format)
  } else {
    Editor.addMark(editor, format, true)
  }
}

const isBlockActive = (editor, format, blockType = 'type') => {
  const { selection } = editor
  if(!selection) return false
  const [match] = Array.from(
    Editor.nodes(editor, {
      at: Editor.unhangRange(editor, selection),
      match: n =>
        !Editor.isEditor(n) &&
        SlateElement.isElement(n) &&
        n[blockType] === format,
    })
  )
  return !!match
}

const isMarkActive = (editor, format) => {
  const marks = Editor.marks(editor)
  return marks ? marks[format] === true : false
}

const fontSizeMap = (size=4) => {
  const sizes = {1: '10px', 2: '13px', 3: '16px', 4: '18px', 5: '24px', 6: '32px', 7: '48px'}
  return sizes[size] || '18px';
}

const isNumeric = (str) => {
  return /^[0-9]+$/.test(str);
}

const Element = ({ attrs, children, element, fullscreen }) => {
  const cstyle = {}
  //if(!element?.type)console.log([element, attrs, children])
  if(element?.size) cstyle.fontSize = (isNumeric(element?.size)&&element?.size!=='')?fontSizeMap(element?.size):element?.size; 
  if(element?.face) cstyle.fontFamily = element.face; 
  
  const attributes = { ...attrs };
  if(element?.width){
    var width = (isNumeric(element.width))?element.width+'px':element.width
    if(element?.type === 'tablecell' || element?.type === 'table'){
      cstyle.flexBasis = width;
      cstyle.width = width;
    }
    else {
      cstyle.width = width;
    }
  } 
  if(element?.height){
    cstyle.minHeight = (isNumeric(element.height))?element.height+'px':element.height
  } 
  if(element?.border){
    cstyle.borderWidth = element.border+'px';
    cstyle.borderStyle = 'solid';
    cstyle.borderColor = '#000';
  }
  if(element?.bgcolor) cstyle.backgroundColor = element.bgcolor
  if(element?.cellPadding) cstyle.padding = element.cellpadding+'px';
  if(element?.cellSpacing) cstyle.margin = element.cellspacing+'px';
  
  if(element?.align) attributes.align = element.align; 
  if(element?.colspan) cstyle.flex = element.colspan;
  const style = { ...cstyle, ...element?.style };

  var className = element?.type ? `${element.type}-element` : 'text-element';

  //console.log([attributes, style, className])

  switch (element?.type) {
    case 'image':
      return <Image {...attributes} element={element} style={style} className={className} >{children}</Image>
    case 'hr':
      return <div {...attributes} style={style} className={className}></div>;
    case 'numberedlist':
      return <ol {...attributes} style={style} className={className}>{children}</ol>;
    case 'bulletedlist':
      return <ul {...attributes} style={style} className={className}>{children}</ul>;
    case 'listitem':
      return <li {...attributes} style={style} className={className}>{children}</li>;
    default:
      return <div {...attributes} style={style} className={className}>{children}</div>;
  }
};

const Leaf = ({ attributes, children, leaf }) => {
  //const editor = useSlate()
  //const path = ReactEditor.findPath(editor, leaf);
  //console.log([attributes, children, leaf])
  var className = "slateLeaf"
  if (leaf.bold) {
    className = className+' bold-leaf'
  }
  if (leaf.code) {
    className = className+' monospace-leaf'
  }
  if (leaf.italic) {
    className = className+' italic-leaf'
  }
  if (leaf.underline) {
    className = className+' underline-leaf'
  }
  if (leaf.br) {
    className = className+' br-leaf'
  }
  if (leaf.var) {
    className = className+' var-element'
  }
  return <div {...attributes} className={className} >{children}</div>
}

const getAncestorTypes = (editor) => {
  const path = editor.selection?.focus?.path
  if (!path) return []

  const types = []
  // Walk from root down to just before the current node
  for (let i = 1; i <= path.length; i++) {
    const ancestorPath = path.slice(0, i)
    const node = Node.get(editor, ancestorPath)
    if ('type' in node && typeof node.type === 'string') {
      types.push(node.type)
    }
  }
  return types
}

const InsertElementButton = ({editor, type, node, path, setOpen}) => {
  const tr = useTranslate();
  const parents = getAncestorTypes(editor)
  var disabled = false
  switch(node.type){
    case 'table':
      disabled = true
      if(['tablerow'].includes(type))disabled = false
      break
    case 'tablerow':
      disabled = true
      if(['tablehead', 'tablecell'].includes(type))disabled = false
      break
    default:
      break
  }
  switch(type){
    case 'tablerow':
      disabled = true
      if(parents.includes('table')){
        disabled = false
      }
      break
    case 'tablehead':
    case 'tablecell':
      disabled = true
      if(parents.includes('tablerow') 
      || parents.includes('tablecell')
      || parents.includes('tablehead')){
        disabled = false
      }
      break
    case 'listitem':
      disabled = true
      if(parents.includes('numberedlist') 
      || parents.includes('bulletedlist')){
        disabled = false
      }
      break
    default:
      break
  }
  return (
    <MButton 
      variant="outlined" 
      onClick={() => {insertElement(editor, path, type);setOpen(false)}} 
      disabled={disabled} >
        {tr('bw.set.bookingsheet.'+type)}
    </MButton>
  )
}

const Button = React.forwardRef(
  ({ className, active, reversed, ...props }, ref) => (
    <span {...props} ref={ref} className={cx( className, css`cursor: pointer; color: ${reversed ? active ? 'white' : '#aaa' : active ? 'black' : '#aaa'};` )} />
  )
)

const BlockButton = ({ format, icon }) => {
  const editor = useSlate()
  return (
    <Button
      active={isBlockActive(
        editor,
        format,
        TEXT_ALIGN_TYPES.includes(format) ? 'align' : 'type'
      )}
      onMouseDown={event => {
        event.preventDefault()
        toggleBlock(editor, format)
      }}
    >
      <Icon>{icon}</Icon>
    </Button>
  )
}

const CButton = ({ active, action, icon }) => {
  return (
    <Button
      active={active}
      onClick={action}
    >
      <Icon>{icon}</Icon>
    </Button>
  )
}

const MarkButton = ({ format, icon }) => {
  const editor = useSlate()
  return (
    <Button
      active={isMarkActive(editor, format)}
      onMouseDown={event => {
        event.preventDefault()
        console.log(editor)
        toggleMark(editor, format)
      }}
    >
      <Icon>{icon}</Icon>
    </Button>
  )
}

const Icon = React.forwardRef(({ className, ...props }, ref) => (
  <span {...props} ref={ref} className={cx( 'material-icons', className, css`font-size: 18px; vertical-align: text-bottom;`)} />
))

const Instruction = React.forwardRef(({ className, ...props }, ref) => (
  <div {...props} ref={ref} className={cx( className, css`white-space: pre-wrap; margin: 0 -20px 10px; padding: 10px 20px; font-size: 14px; background: #f8f8e8;`)} />
))

const Menu = React.forwardRef(({ className, ...props }, ref) => (
  <div {...props} data-test-id="menu" ref={ref} className={cx( className, css`& > * { display: inline-block; } & > * + * { margin-left: 15px; }` )} />
))

const Portal = ({ children }) => {
  return typeof document === 'object' ? ReactDOM.createPortal(children, document.body) : null
}

const Toolbar = React.forwardRef(({ className, ...props }, ref) => (
  <Menu {...props} ref={ref} className={cx( className, css`position: relative; padding: 1px 18px 1px; margin: 0 -20px; border-bottom: 2px solid #eee; margin-bottom: 15px;` )} />
))

export { Button, Icon, Instruction, Menu, Portal, Toolbar, serialize, deserializeHtml, MarkButton, BlockButton, CButton, Leaf, Element, toggleMark, toggleBlock, ImageButton, InsertElementButton, InsertInput, ParamContext, ParamProvider, DocumentInput };